module.exports = __webpack_public_path__ + "img/companyabout.37ccd882.png";